export const cubicBezier = (a, b, c, d) =>
  `cubic-bezier(${a}, ${b}, ${c}, ${d})`

export const scale3d = (a, b, c) => `scale3d(${a}, ${b}, ${c})`

export const translate3d = (a, b, c) => `translate3d(${a}, ${b}, ${c})`
